import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectOutbound = (state: RootState) => state.outbound;

export const getAllCampaigns = createSelector([selectOutbound], (outbound) => outbound.campaigns);

export const getCampaignsArray = createSelector([getAllCampaigns], (campaigns) =>
	Object.values(campaigns),
);

export const getCurrentCampaign = createSelector(
	[selectOutbound],
	(outbound) => outbound.currentCampaign,
);

export const getCampaignById = (id: string) =>
	createSelector([getAllCampaigns], (campaigns) => campaigns[id] || null);

export const getCampaignsByStatus = (status: 'Active' | 'Paused' | 'Draft') =>
	createSelector([getCampaignsArray], (campaigns) =>
		campaigns.filter((campaign) => campaign.status === status),
	);
